/* Auto Finesse shared link behaviour v1.1 */
(()=>{
  const initHeroNavigation=(root=document)=>{
    root.querySelectorAll('.af-hero-render__navigation').forEach(nav=>{
      if(nav.dataset.afHeroNavReady)return;
      nav.dataset.afHeroNavReady='true';

      const track=nav.querySelector('.af-hero-render__navigation-track');
      if(!track)return;

      let frame=0;
      const updateState=()=>{
        frame=0;
        const maxScroll=Math.max(0,track.scrollWidth-track.clientWidth);
        const currentScroll=Math.max(0,track.scrollLeft);
        const hasOverflow=maxScroll>1;
        const reachedEnd=!hasOverflow||currentScroll>=maxScroll-2;

        nav.classList.toggle('is-overflowing',hasOverflow);
        nav.classList.toggle('is-scrolled',hasOverflow&&currentScroll>2);
        nav.classList.toggle('is-at-end',reachedEnd);
      };

      const queueUpdate=()=>{
        if(frame)return;
        frame=requestAnimationFrame(updateState);
      };

      track.addEventListener('scroll',queueUpdate,{passive:true});

      track.addEventListener('wheel',e=>{
        if(!nav.classList.contains('is-overflowing'))return;
        if(Math.abs(e.deltaY)<=Math.abs(e.deltaX))return;

        const maxScroll=Math.max(0,track.scrollWidth-track.clientWidth);
        if(maxScroll<=1)return;

        const nextScroll=Math.min(maxScroll,Math.max(0,track.scrollLeft+e.deltaY));
        if(nextScroll===track.scrollLeft)return;

        e.preventDefault();
        track.scrollLeft=nextScroll;
        queueUpdate();
      },{passive:false});

      if(typeof ResizeObserver==='function'){
        const observer=new ResizeObserver(queueUpdate);
        observer.observe(track);
      }

      queueUpdate();
    });
  };

  const getHeaderOffset=()=>{
    const configured=Number(document.documentElement.style.getPropertyValue('--af-anchor-offset').replace('px',''))||0;
    if(configured)return configured;
    const header=document.querySelector('[data-header-sticky],.shopify-section-group-header-group,.header-section');
    return header?header.getBoundingClientRect().height:0;
  };
  const scrollToTarget=target=>{
    if(!target)return;
    const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
    const top=target.getBoundingClientRect().top+scrollY-getHeaderOffset();
    scrollTo({top,behavior:reduced?'auto':'smooth'});
  };
  const init=(root=document)=>{
    initHeroNavigation(root);

    root.querySelectorAll('[data-af-link]').forEach(link=>{
      if(link.dataset.afLinkReady)return;
      link.dataset.afLinkReady='true';
      link.addEventListener('click',e=>{
        if(link.hasAttribute('data-af-scroll-next')){
          const currentSection=link.closest('.shopify-section,[id^="shopify-section-"]');
          const nextSection=currentSection?.nextElementSibling;
          if(!nextSection)return;
          e.preventDefault();
          scrollToTarget(nextSection);
          return;
        }
        const href=link.getAttribute('href')||'';
        if(!href.startsWith('#')||href==='#')return;
        let target;
        try{target=document.querySelector(href)}catch(_){return}
        if(!target)return;
        e.preventDefault();
        scrollToTarget(target);
        history.pushState(null,'',href);
      });
    });
  };
  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',()=>init()):init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
